<template>
  <!-- Без Transition намеренно: обрыв и восстановление связи могут случиться
       в одном тике (первый запрос упал, повтор тут же прошёл), и анимация
       появления, перебитая анимацией ухода, оставляла элемент в DOM с
       opacity 0 навсегда — проверено на staging 21.09.2026. -->
  <div v-if="state" class="fixed top-0 left-0 right-0 z-[140] flex justify-center pointer-events-none">
    <div
      class="w-full max-w-[430px] px-3 pointer-events-auto"
      style="padding-top: max(8px, var(--safe-area-inset-top, env(safe-area-inset-top, 0px)))"
    >
      <div
        class="net-sheet rounded-2xl bg-cream text-ink shadow-lg px-4 py-3 flex items-start gap-3"
        role="status"
        aria-live="polite"
        @click="dismiss"
      >
        <!-- Иконка состояния: нет сети / сервер / галочка -->
        <svg v-if="state.kind === 'device'" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" class="shrink-0 mt-[1px] text-ink/70">
          <path d="M2 9a16 16 0 0 1 7-3.5M12 13a8 8 0 0 1 4.3 1.3M8.5 16.5a4 4 0 0 1 4.6-.6M22 9a16 16 0 0 0-8.3-4M12 20h.01"/>
          <line x1="3" y1="3" x2="21" y2="21"/>
        </svg>
        <svg v-else-if="state.kind === 'server'" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" class="shrink-0 mt-[1px] text-ink/70">
          <rect x="3" y="4" width="18" height="7" rx="2"/><rect x="3" y="13" width="18" height="7" rx="2"/>
          <path d="M7 7.5h.01M7 16.5h.01"/>
        </svg>
        <svg v-else-if="state.kind === 'syncing'" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" class="shrink-0 mt-[1px] text-ink/70 animate-spin" style="animation-duration: 1.4s">
          <path d="M21 12a9 9 0 1 1-2.6-6.4"/><path d="M21 3v6h-6"/>
        </svg>
        <svg v-else width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" class="shrink-0 mt-[1px]" style="color: #5F8F4E">
          <circle cx="12" cy="12" r="9"/><path d="M8 12.5l2.5 2.5L16 9.5"/>
        </svg>
        <div class="flex-1 min-w-0">
          <p class="text-14 font-semibold leading-snug">{{ state.title }}</p>
          <p v-if="state.text" class="text-13 text-ink/70 leading-snug mt-[2px]">{{ state.text }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
// Шторка состояния связи. Обещаем ровно то, что правда: сохранённое цело,
// неотправленное остаётся на экране и уходит само при возврате связи
// (services/netStatus.js). Тон один: что случилось, что цело, что сделать;
// без слова «ошибка».
import { computed, ref, watch } from 'vue'
import { offline, reason, restored, syncing, synced } from '../services/netStatus.js'

const TEXTS = {
  device:  { title: 'Нет интернета',        text: 'Дневник показан по последнему снимку. Как только связь появится, всё обновится само.' },
  server:  { title: 'Сервер не отвечает',   text: 'Проверьте соединение. Всё сохранённое на месте, а введённое останется на экране до повтора.' },
  syncing: { title: 'Связь восстановлена',  text: 'Сохраняю то, что не ушло…' },
  synced:  { title: 'Сохранено',            text: '' },
  restored:{ title: 'Связь восстановлена',  text: 'Обновляю дневник.' },
}

// Смахнуть можно только «нет связи»: до следующей смены состояния
const dismissedKind = ref(null)

const state = computed(() => {
  if (syncing.value) return { kind: 'syncing', ...TEXTS.syncing }
  if (synced.value)  return { kind: 'synced',  ...TEXTS.synced }
  if (offline.value) {
    const kind = reason.value === 'device' ? 'device' : 'server'
    if (dismissedKind.value === kind) return null
    return { kind, ...TEXTS[kind] }
  }
  if (restored.value) return { kind: 'restored', ...TEXTS.restored }
  return null
})

watch(offline, (v) => { if (!v) dismissedKind.value = null })
watch(reason, () => { dismissedKind.value = null })

function dismiss() {
  if (state.value && (state.value.kind === 'device' || state.value.kind === 'server')) {
    dismissedKind.value = state.value.kind
  }
}
</script>

<style scoped>
.net-sheet {
  font-family: Inter, sans-serif;
  border: 1px solid rgba(65, 41, 26, 0.12);
}
</style>
